const androidAppFeatures = [
  'Reusable React Native route replay map component',
  'Animates a vehicle marker along historical GPS route data',
  'Supports speed-based route coloring to visualize movement intensity',
  'Includes playback controls like start, stop, and progress tracking',
  'Displays trip statistics such as time, speed, and distance',
  'Detects stop points and marks them on the map',
  'Supports custom start, end, stop, and vehicle markers',
  'Works with dummy data for development and API data for production',
  'Exposes separate components, hooks, and utilities for easy customization',
  'Built on react-native-maps for Android and iOS map rendering',

];

const androidAppDeliverables = [
  {
    title: "Complete App Source Code",
    description:
      "Production-ready mobile app module source code that your team can integrate, customize, and extend.",
  },
  {
    title: "Product Documentation",
    description:
      "Step-by-step documentation to help with installation, configuration, integration, and handover.",
  },
];

const productRequirements = [
  'Node.js 22.11.0 or higher',
  'Yarn or npm package manager',
  'React Native development environment setup',
  'Android Studio for running the Android app',
  'Xcode for running the iOS app on macOS',
  'CocoaPods installed for iOS dependencies',
  'Install project dependencies using yarn install or npm install',
  'Run pod install inside the ios folder before running on iOS',
  'Google Maps setup may be required for react-native-maps depending on platform configuration',
  'Internet connection is required when using API route data',
  'No API is required for dummy data mode because src/dummyRouteResponse.js is already included',
];

export const products = [
  {
    slug: "routemotion-vehicle-movement-animation",
    title: "RouteMotion — React Native Vehicle Tracking Module",
    description:
      "Production-ready React Native module for smooth vehicle tracking, route playback, and real-time map animation.",
    longDescription: "RouteMotion is a production-ready React Native vehicle tracking module built for smooth route playback, live vehicle animation, real-time route drawing, speed tracking, and trip visualization. It helps developers build modern logistics, delivery, and fleet tracking apps faster while saving weeks of development time.",
    buttonText: "Request To Buy",
    price: "$19",
    softwareVersion: " v1.0.0",
    compatibility: " React Native 0.70+",
    image: "/assets/img/routemotion_product.png",
    demoGif: "/assets/img/Route_Motion_Product_Video_V1-ezgif.com-video-to-gif-converter.gif",
    videoUrl: "https://youtube.com/shorts/isSzTjYTK_4?feature=share",
    apkUrl: "/assets/apk/routemotion.apk",
    documentationUrl: "/assets/Appscasa-RouteReplay-Setup.html",
    features: androidAppFeatures,
    deliverables: androidAppDeliverables,
    productRequirements,
    updatedAt: " 2024-06-01",
  }
];
